import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { I18n } from "@jti/ui/components/I18n";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import styles from "./ConsumablesSectionTitle.module.scss";
export const ConsumablesSectionTitle = ({ translationKey, stepCount, children, ...restProps }) => {
    const { __ } = useTranslations();
    return (_jsx("div", { ...restProps, children: _jsxs(I18n, { t: translationKey, children: [_jsx("strong", { className: styles.stepCountLabel, children: __("consumablesForm.section.title.stepCount", [stepCount]) }), children] }) }));
};
//# sourceMappingURL=ConsumablesSectionTitle.js.map